import { takeLatest, call, put, select } from 'redux-saga/effects';
import onboardingActions from './actions';
import errorActions from '../error/actions';
import authActions from '../auth/actions';
import dxApi from 'services/dxApi';
import history from 'store/history';

const {
  Types: { LOAD_ONBOARDING_STEPS_REQUEST, SUBMIT_ONBOARDING_RESPONSE_REQUEST },
  Creators: {
    loadOnboardingStepsSuccess,
    loadOnboardingStepsFailure,
    submitOnboardingResponseSuccess,
    submitOnboardingResponseFailure,
  },
} = onboardingActions;

const {
  Creators: { setError },
} = errorActions;

function* loadOnboardingSteps() {
  try {
    const { data } = yield call(dxApi.get, '/onboarding/steps?isPortal=true');

    if (!data.success) {
      yield put(loadOnboardingStepsFailure(data.message));
      yield put(setError(data.message));
    } else {
      yield put(loadOnboardingStepsSuccess(data.data));
    }
  } catch (error) {
    yield put(loadOnboardingStepsFailure(error));
  }
}

function* submitOnboardingResponse({ responseData }) {
  try {
    const { data } = yield call(dxApi.put, '/onboarding/response', responseData);

    if (!data.success) {
      yield put(submitOnboardingResponseFailure(data.message));
      yield put(setError(data.message));
    } else {
      yield put(submitOnboardingResponseSuccess(data.data));
    }
  } catch (error) {
    yield put(submitOnboardingResponseFailure(error));
  }
}

export function* onboardingSaga() {
  yield takeLatest(LOAD_ONBOARDING_STEPS_REQUEST, loadOnboardingSteps);
  yield takeLatest(SUBMIT_ONBOARDING_RESPONSE_REQUEST, submitOnboardingResponse);
}
